import { gql } from '@apollo/client';

export const CREATE_CLARIFICATION_SCHEMA = gql`
  mutation CreateClarificationSchema($params: CreateClarificationSchemaInput!) {
    createClarificationSchema(params: $params) {
      success
      message
      errors
      data {
        id
        entity
        matchEntities
        type
        relatedEntities
        finalQueryTemplate
        personKeywords
        description
        triggerKeywords
        maxResultsWithoutClarification
        parentSchemaId
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_CLARIFICATION_SCHEMA = gql`
  mutation UpdateClarificationSchema($params: UpdateClarificationSchemaInput!) {
    updateClarificationSchema(params: $params) {
      success
      message
      errors
      data {
        id
        entity
        matchEntities
        type
        relatedEntities
        finalQueryTemplate
        personKeywords
        description
        triggerKeywords
        maxResultsWithoutClarification
        parentSchemaId
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_CLARIFICATION_SCHEMA = gql`
  mutation DeleteClarificationSchema($params: DeleteClarificationSchemaInput!) {
    deleteClarificationSchema(params: $params) {
      success
      message
      errors
    }
  }
`;
